/**
 * SXTNotificationList - to display notifications which includes SXTNotification
 *
 * @version 1.0.1
 * @author [Karthick Shanmugam](https://github.com/karthickShanmugam0689)
 */
import * as React from 'react'
import {IListProps, INotification} from './SXTNotification.d'
import LazyLoadGroup from '../LazyLoad/LazyLoadGroup'
import SXTNotification from './SXTNotification'
import SXTEmptyData from './SXTEmptyData'
const SXTNotificationList = (props: IListProps) => {
  const {notifications, showTag, isLighterView, isLoading, root} = props

  return (
    <>
      {notifications && notifications.length > 0 ? (
        <LazyLoadGroup
          items={notifications}
          batchSize={10}
          minHeight={65}
          root={root}
          renderItem={(notification: INotification) => (
            <SXTNotification
              key={notification.id}
              notification={notification}
              showTag={showTag}
              isLighterView={isLighterView}
            />
          )}
        />
      ) : (
        !isLoading && <SXTEmptyData />
      )}
    </>
  )
}

export default React.memo(SXTNotificationList)
